import { InternalAxiosRequestConfig } from "axios";
import { v4 as uuidv4 } from "uuid";
import { useDeviceInfo } from "../../feat/appState/deviceInfo";
export const spTraceInterReq = (request: InternalAxiosRequestConfig) => {
  const buildVersion = useDeviceInfo.getState().version.buildVersion;
  const reactVersion = useDeviceInfo.getState().version.reactVersion;

  request.headers["X-SP-Trace-Id"] = uuidv4();
  request.headers["X-Eventr-App"] = "EventRApp";
  request.headers["X-EventR-BuildV"] = buildVersion;
  request.headers["X-EventR-ReactV"] = reactVersion;

  return request;
};
